import LazyLoad from 'lazyload'

window.addEventListener('load', () => {
  new LazyLoad(document.querySelectorAll('img'), { src: 'data-original' })
})
